import React, { useState, useEffect } from "react";
import { Layout, message } from "antd";
import InvoiceSummary from "../Dashboard/InvoiceSummary";
import InvoiceStatusButtons from "../Dashboard/InvoiceStatusButtons";
import InvoiceFilters from "../Dashboard/InvoiceFilters";
import InvoiceTable from "../Dashboard/InvoiceTable";
import axios from "axios";
import dayjs from "dayjs";

const { Content, Header } = Layout;

const Dashboard = () => {
    const [invoices, setInvoices] = useState([]);
    const [filteredInvoices, setFilteredInvoices] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("all");
    const [searchText, setSearchText] = useState("");
    const [suppliers, setSuppliers] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [invoiceType, setInvoiceType] = useState("all");
    const [selectedSupplier, setSelectedSupplier] = useState(null);

    useEffect(() => {
        fetchInvoices();
        fetchSuppliers();
    }, []);

    const fetchInvoices = async () => {
        try {
            const response = await axios.get("https://api-invoice.foodchainflow.de/api/invoices");
            setInvoices(response.data);
            setFilteredInvoices(response.data);
        } catch (error) {
            message.error("Fehler beim Laden der Rechnungen.");
            console.error(error);
        }
    };

    const fetchSuppliers = async () => {
        try {
            const response = await axios.get("https://api-invoice.foodchainflow.de/api/suppliers");
            setSuppliers(response.data);
        } catch (error) {
            console.error("Fehler beim Laden der Lieferanten:", error);
        }
    };

    useEffect(() => {
        applyFilters();
    }, [selectedStatus, searchText, selectedSupplier, dateRange, invoiceType]);

    const applyFilters = () => {
        let filtered = Array.isArray(invoices) ? [...invoices] : [];

        if (searchText) {
            filtered = filtered.filter((inv) => inv.invoice_id.includes(searchText));
        }

        if (selectedSupplier) {
            filtered = filtered.filter((inv) => inv.supplier_name && inv.supplier_name.trim() === selectedSupplier.trim());
        }

        if (dateRange.length === 2) {
            const [start, end] = dateRange;
            filtered = filtered.filter((inv) =>
                dayjs(inv.invoice_date).isBetween(start, end, null, "[]")
            );
        }

        if (selectedStatus !== "all") {
            filtered = filtered.filter((inv) => {
                switch (selectedStatus) {
                    case "notCompleted":
                        return inv.legal_review !== "approved" ||
                            inv.content_review !== "approved" ||
                            inv.accounting !== "approved" ||
                            inv.payment_approval !== "approved";
                    case "legalReview":
                        return inv.legal_review === "pending";
                    case "contentReview":
                        return inv.content_review === "pending";
                    case "accounting":
                        return inv.accounting === "pending";
                    case "payment":
                        return inv.payment_approval === "pending";
                    case "completed":
                        return inv.legal_review === "approved" &&
                            inv.content_review === "approved" &&
                            inv.accounting === "approved" &&
                            inv.payment_approval === "approved";
                    default:
                        return true;
                }
            });
        }

        setFilteredInvoices(filtered || []);
    };

    return (
        <Layout style={{ minHeight: "100vh", background: "#f5f5f5", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Content style={{ width: "90%", maxWidth: "1200px", background: "#fff", padding: "20px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)" }}>
                <Header style={{ background: "#5a7489", color: "#fff", fontSize: "18px", textAlign: "center", borderRadius: "8px" }}>
                    Rechnungsprüfung ( Inbox: invoices@foodchainflow.de )
                </Header>

                <InvoiceSummary invoices={invoices} />
                <InvoiceStatusButtons invoices={invoices} selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus} setFilteredInvoices={setFilteredInvoices} />
                <InvoiceFilters setSearchText={setSearchText} setSelectedSupplier={setSelectedSupplier} setDateRange={setDateRange} selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus} invoiceType={invoiceType} setInvoiceType={setInvoiceType} suppliers={suppliers} />

                <InvoiceTable invoices={filteredInvoices} />
            </Content>
        </Layout>
    );
};

export default Dashboard;
